"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyPenders;

var _pender = require("./pender");

var _pender2 = _interopRequireDefault(_pender);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Applys penders to the reducer
 * @param {*} reducer original reducer
 * @param {*} penders array of penders
 */
function applyPenders(reducer, penders) {
  var updaters = Object.assign.apply(Object, [{}].concat(_toConsumableArray(penders.map(_pender2.default))));
  var enhancedReducer = function enhancedReducer(state, action) {
    if (updaters[action.type]) {
      return updaters[action.type](state, action);
    }
    return reducer(state, action);
  };
  return enhancedReducer;
}